var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-crud-grid',{attrs:{"title":_vm.title,"mode":_vm.mode,"modal":_vm.modal,"backend":_vm.backend},on:{"save":function (data) { return _vm.$emit('save', data); }}})}
var staticRenderFns = []

export { render, staticRenderFns }